'use client'

import { useFormState, useFormStatus } from 'react-dom'
import { login } from '@/app/actions/auth'

function SubmitButton() {
  const { pending } = useFormStatus()
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full py-2.5 rounded-xl text-white font-semibold text-sm transition-opacity disabled:opacity-60"
      style={{ background: 'linear-gradient(135deg,#F0997B,#D85A30)' }}
    >
      {pending ? '로그인 중...' : '로그인'}
    </button>
  )
}

export default function LoginPage() {
  const [state, formAction] = useFormState(login, null)

  const isUnauthorized = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('error') === 'unauthorized'

  return (
    <main className="min-h-screen flex items-center justify-center" style={{ background: '#F5F7FA' }}>
      <div className="w-full max-w-sm px-4">

        {/* 로고 */}
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-2xl text-white text-2xl font-bold mb-3"
            style={{ background: 'linear-gradient(135deg,#F0997B,#D85A30)' }}
          >
            B
          </div>
          <h1 className="text-2xl font-bold" style={{ color: '#1A1A2E' }}>Bricks 학부모</h1>
          <p className="text-sm mt-1" style={{ color: '#6B7280' }}>자녀의 학습을 함께 확인해요</p>
        </div>

        <div className="rounded-2xl p-6 shadow-sm" style={{ background: '#fff', border: '1px solid #E5E7EB' }}>
          {isUnauthorized && (
            <p className="text-xs px-3 py-2 rounded-lg mb-4 text-center"
              style={{ background: '#FEF3C7', color: '#92400E' }}>
              학부모 계정으로만 로그인할 수 있습니다.
            </p>
          )}

          <form action={formAction} className="space-y-4">
            <div className="space-y-1.5">
              <label htmlFor="email" className="block text-sm font-medium" style={{ color: '#374151' }}>
                이메일
              </label>
              <input
                id="email" name="email" type="email" autoComplete="email" required
                placeholder="parent@example.com"
                className="w-full px-3 py-2.5 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                style={{ borderColor: '#E5E7EB', background: '#F9FAFB' }}
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="password" className="block text-sm font-medium" style={{ color: '#374151' }}>
                비밀번호
              </label>
              <input
                id="password" name="password" type="password" autoComplete="current-password" required
                placeholder="••••••••"
                className="w-full px-3 py-2.5 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                style={{ borderColor: '#E5E7EB', background: '#F9FAFB' }}
              />
            </div>

            {state?.error && (
              <p className="text-sm rounded-lg px-3 py-2"
                style={{ background: '#FEE2E2', color: '#991B1B' }}>
                {state.error === 'Invalid login credentials'
                  ? '이메일 또는 비밀번호가 올바르지 않습니다.'
                  : state.error}
              </p>
            )}

            <SubmitButton />
          </form>

          <div className="mt-4 text-center">
            <a href="/forgot-password" className="text-xs" style={{ color: '#6B7280' }}>
              비밀번호를 잊으셨나요?
            </a>
          </div>
        </div>

        <p className="text-center text-xs mt-6" style={{ color: '#9CA3AF' }}>
          계정은 학원에서 발급합니다. 담당 선생님께 문의해주세요.
        </p>
      </div>
    </main>
  )
}
